{
	"deletePhotoFailed_one": "Failed to delete photo",
	"deletePhotoFailed_other": "Failed to delete {{count}} photos",
	"deleteVirtualCopyFailed_one": "Failed to delete virtual copy.",
	"deleteVirtualCopyFailed_other": "Failed to delete {{count}} virtual copies."
}
